import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { BsArrowRight } from 'react-icons/bs'
import AuthenticatedRoutes from '../../Utils/AuthenticatedRoutes'
import './auth.css'
import {
  Box,
  Button,
  calc,
  Center,
  Flex,
  Heading,
  Image,
  Text,
} from '@chakra-ui/react'
import NavbarOpen from '../NavLinks/NavbarOpen'
import { getConnectionUrl } from '../../Api/user'

const LoginAgain = () => {
  const navigate = useNavigate()

  const getConnectionUrlHandler = useCallback(async () => {
    const apiResponse = await getConnectionUrl(window.location.href)
    if (apiResponse?.url) {
      window.open(apiResponse.url, '_blank')
    }
  }, [])

  return (
    <Box h='100vh'>
      <NavbarOpen />
      <Box>
        {/* <AuthenticatedRoutes auth={false} /> */}
        <Box>
          <Flex justify='center'>
            <Center w='50%' color='black' h='calc(100vh - 70px)' align='center'>
              <Box mt='-60px'>
                {/* change the color of the below image to very light gray*/}
                <Image
                  src='/assets/icons/calendarDenied.svg'
                  mb='37px'
                  color='gray.200'
                />
                <Heading
                  fontSize='5xl'
                  color='black'
                  px='70px'
                  lineHeight='1'
                  mb='40px'
                >
                  Permissions let us cross valleys for you
                </Heading>
                <Box w='50%'>
                  <Text color='black' mb='42px' align='left' fontSize='17px'>
                    You need to give Google access to your data for Arrowhead to{' '}
                    <Text
                      as='span'
                      color='black'
                      fontWeight='700'
                      fontStyle='italic'
                    >
                      work its magic!{''}
                    </Text>
                    <Text mt='2rem' color='black'>
                      Note: We do not change any of the information in your
                      calendar. and .
                    </Text>
                  </Text>
                </Box>

                <Button
                  bg='black'
                  _hover={{ bg: 'black' }}
                  px='30px'
                  onClick={getConnectionUrlHandler}
                >
                  <Flex align='center'>
                    <Box mr={2}>
                      <Image src='/assets/icons/google.svg' boxSize={4} />{' '}
                    </Box>
                    <Text fontSize='md'>Continue with Google</Text>
                  </Flex>
                </Button>
              </Box>
            </Center>
            <Center w='50%' bg='#E2D7F5' h='calc(100vh - 70px)' align='center'>
              <Box mt='-75px'>
                <Image
                  borderRadius='full'
                  boxSize='100px'
                  src='https://bit.ly/dan-abramov'
                  bg='white'
                  objectFit='cover'
                  mb='34px'
                />
                <Text color='black' px='200px' fontWeight={500} fontSize='21px'>
                  “A great tool for capturing and sharing customer feedback!”
                </Text>
              </Box>
            </Center>
          </Flex>
        </Box>
      </Box>
    </Box>
  )
}

export default LoginAgain
